import { ImageViewerBehavior } from "./ImageViewerBehavior";

export class ImageViewerValues {
    private _id: string;
    private _imageBase64: string;
    private _fileName: string;
    private _title?: string;
    private _allowEmail: boolean;
    private _allowDownloads: boolean;
    private _showOpenInButtons: boolean;
    private _displayZoomControls: boolean;

    constructor(
        id: string,
        imageBase64: string,
        fileName?: string,
        title?: string,
        allowEmail?: boolean,
        allowDownloads?: boolean,
        showOpenInButtons?: boolean,
        displayZoomControls?: boolean
    ) {
        this._id = id;
        this.imageBase64 = imageBase64;
        this.fileName = fileName;
        this.title = title;
        this.allowEmail = allowEmail;
        this.allowDownloads = allowDownloads;
        this.showOpenInButtons = showOpenInButtons;
        this.displayZoomControls = displayZoomControls;
    }

    public get id(): string {
        return this._id;
    }

    private set id(value: string) {
        this._id = value;
    }

    public get imageBase64(): string {
        return this._imageBase64;
    }

    private set imageBase64(value: string) {
        this._imageBase64 = value;
    }

    public get fileName(): string {
        return this._fileName;
    }

    private set fileName(value: string) {
        this._fileName = value;
    }

    public get title(): string {
        return this._title ?? this.fileName;
    }

    private set title(value: string) {
        this._title = value;
    }

    public get allowEmail(): boolean {
        return this._allowEmail ?? this.behaviors.allowEmailDefault;
    }

    private set allowEmail(value: boolean) {
        this._allowEmail = value;
    }

    public get allowDownloads(): boolean {
        return this._allowDownloads ?? this.behaviors.allowDownloadsDefault;
    }

    private set allowDownloads(value: boolean) {
        this._allowDownloads = value;
    }

    public get showOpenInButtons(): boolean {
        return this._showOpenInButtons ?? this.behaviors.showOpenInButtonsDefault;
    }

    private set showOpenInButtons(value: boolean) {
        this._showOpenInButtons = value;
    }

    public get displayZoomControls(): boolean {
        return this._displayZoomControls ?? this.behaviors.displayZoomControlsDefault;
    }

    private set displayZoomControls(value: boolean) {
        this._displayZoomControls = value;
    }

    /**
     * Implement toJSON so that the info is serialized in the desired format.
     * @returns any
     */
    public toJSON(): any {
        return {
            id: this.id,
            imageBase64: this.imageBase64,
            fileName: this.fileName,
            title: this.title,
            allowEmail: this.allowEmail,
            allowDownloads: this.allowDownloads,
            showOpenInButtons: this.showOpenInButtons,
            displayZoomControls: this.displayZoomControls
        };
    }

    private get behaviors(): ImageViewerBehavior {
        return ImageViewerBehavior.behaviors;
    }
}
